(() => {
  const root = document.querySelector('[data-lcr]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const input = root.querySelector('#lcr-code');
  if (!input) return;
  const form = root.querySelector('form');
  const status = root.querySelector('[role="status"]');
  const codeList = root.querySelector('[data-codes]');
  const cartUrl = root.dataset.cartUrl;
  let codes = [];
  let busy = false;
  const autoEnabled = root.dataset.autoNew1000 === 'true';
  const autoCode = 'NEW1000';
  let manualCouponAction = false;
  const hash = value => {
    let number = 2166136261;
    for (const character of String(value)) number = Math.imul(number ^ character.charCodeAt(0), 16777619);
    return (number >>> 0).toString(36);
  };
  const autoState = data => {
    if (!autoEnabled || !data.token) return null;
    try {
      const key = 'londa-cart-new1000-' + hash(data.token);
      const value = JSON.parse(localStorage.getItem(key) || '{}');
      return {key, value};
    } catch (_) { return null; }
  };
  const saveAutoState = state => {
    try {localStorage.setItem(state.key, JSON.stringify(state.value));return true;} catch (_) {return false;}
  };
  const rememberManualChoice = data => {
    const state = autoState(data);
    if (state) {state.value.declined = true;saveAutoState(state);}
  };
  const cartSignature = data => hash(JSON.stringify([data.currency, data.original_total_price, (data.items || []).map(item => [item.key, item.quantity])]));
  const hasDiscount = data => (data.discount_codes || []).length > 0 || Number(data.total_discount) > 0 ||
    (data.cart_level_discount_applications || []).length > 0 || (data.items || []).some(item =>
      Number(item.total_discount) > 0 || (item.discounts || []).length > 0 ||
      (item.line_level_discount_allocations || []).length > 0 || (item.discount_allocations || []).length > 0);
  const autoCandidate = data => autoEnabled && !manualCouponAction && !input.value.trim() &&
    data.currency === 'JPY' && Number(data.item_count) > 0 && Number(data.original_total_price) >= 650000 && !hasDiscount(data);
  const show = (message, error = false) => { status.textContent = message; status.dataset.error = String(error); };
  const request = async (endpoint, body) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const options = body === undefined ? {headers: {Accept: 'application/json'}} : {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)};
      const response = await fetch(cartUrl + endpoint, {...options, signal: controller.signal});
      if (!response.ok) throw new Error('cart-request');
      return await response.json();
    } finally {clearTimeout(timeout);}
  };
  const remember = (message, error) => { try {sessionStorage.setItem('londa-cart-status', JSON.stringify({message,error}));} catch (_) {} };
  const redrawCodes = data => {
    codes = Array.isArray(data.discount_codes) ? data.discount_codes.filter(c => c.applicable) : [];
    codeList.replaceChildren();
    codes.forEach(c => {
      const row = document.createElement('div'); row.className = 'lcr-code-tag';
      const text = document.createElement('span'); text.textContent = c.code + ' · ' + root.dataset.applied;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = root.dataset.removeCode;
      remove.addEventListener('click', () => updateDiscount(null,c.code));
      row.append(text,remove);codeList.append(row);
    });
  };
  const lock = value => { busy=value; root.querySelectorAll('button,input,textarea').forEach(el => el.disabled=value); };
  const maybeAutoApply = async initial => {
    if (!autoEnabled || busy) return;
    const firstState = autoState(initial);
    if (!firstState) return;
    const alreadyPresent = (initial.discount_codes || []).some(code => code.code.toUpperCase() === autoCode);
    if (firstState.value.applied && !alreadyPresent) {
      firstState.value.declined = true;
      saveAutoState(firstState);
    }
    if (!autoCandidate(initial) || firstState.value.declined || firstState.value.attempt === cartSignature(initial)) return;
    lock(true);
    try {
      const fresh = await request('.js');
      const state = autoState(fresh);
      redrawCodes(fresh);
      if (!state || !autoCandidate(fresh) || state.value.declined || state.value.attempt === cartSignature(fresh)) return;
      state.value.attempt = cartSignature(fresh);
      if (!saveAutoState(state)) return;
      const data = await request('/update.js', {discount: autoCode});
      const accepted = (data.discount_codes || []).some(code => code.applicable && code.code.toUpperCase() === autoCode);
      redrawCodes(data);
      if (accepted) {
        state.value.applied = true;
        saveAutoState(state);
        remember(root.dataset.autoSuccess, false);
        window.location.reload();
      } else if ((data.discount_codes || []).some(code => code.code.toUpperCase() === autoCode)) {
        show(root.dataset.autoPending, false);
      }
    } catch (_) {
      show(root.dataset.autoUnavailable, false);
    } finally {lock(false);}
  };
  const updateDiscount = async (add,remove) => {
    if (busy) return;
    if (add !== null && !add) { show(root.dataset.emptyCode,true); input.focus();return; }
    lock(true);
    manualCouponAction = true;
    try {
      const fresh = await request('.js');
      rememberManualChoice(fresh);
      const current = (fresh.discount_codes || []).filter(c => c.applicable).map(c=>c.code);
      let next = current.filter(c=>!remove || c.toUpperCase()!==remove.toUpperCase());
      if (add && !next.some(c=>c.toUpperCase()===add.toUpperCase())) next.push(add);
      const body = {discount:next.join(',')};
      const note = root.querySelector('[name="note"]'); if(note) body.note=note.value;
      const data = await request('/update.js',body);
      const applied = (data.discount_codes || []).some(c=>c.applicable && add && c.code.toUpperCase()===add.toUpperCase());
      if (add && !applied) {
        await request('/update.js',{discount:current.join(',')});
        remember(root.dataset.invalid,true);
      } else { remember(remove ? root.dataset.removed : root.dataset.success,false); }
      window.location.reload();
    } catch (_) {show(root.dataset.failure,true);lock(false);}
  };
  root.querySelector('[data-apply-code]').addEventListener('click',()=>updateDiscount(input.value.trim(),null));
  input.addEventListener('input',()=>{manualCouponAction=true;});
  input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();updateDiscount(input.value.trim(),null);}});
  form.addEventListener('submit',event=>{if(busy) event.preventDefault();});
  root.querySelectorAll('[data-remove-item]').forEach(button=>button.addEventListener('click',async()=>{
    if(busy)return;lock(true);
    try {await request('/change.js',{id:button.dataset.removeItem,quantity:0});window.location.reload();}
    catch(_){show(root.dataset.failure,true);lock(false);}
  }));
  try {const saved=JSON.parse(sessionStorage.getItem('londa-cart-status')||'null'); if(saved) {show(saved.message,saved.error);sessionStorage.removeItem('londa-cart-status');}} catch(_){}
  request('.js').then(data=>{redrawCodes(data);return maybeAutoApply(data);}).catch(()=>{});
})();
